import React, { Fragment } from 'react';

import './Beer.css';

const Beer = ({ beer }) => {
  return (
    <Fragment>
      <div className="beer-left">
        <div className="content-wrapper mobile">
          <h2>
            {beer.titre}
            <br />
            <span>{beer.sous_titre}</span>
          </h2>
        </div>
        <img src={beer.image.url} />
      </div>
      <div className="beer-right">
        <div className="content-wrapper">
          <h2 className="desktop">
            {beer.titre}
            <br />
            <span>{beer.sous_titre}</span>
          </h2>
          <p>
            <span>
              Ingrédients : <br />
              {beer.ingredients}
            </span>
          </p>
          <p
            className="description"
            dangerouslySetInnerHTML={{ __html: beer.description }}
          />
          <p>
            <span>{beer.alcool}</span>
          </p>
          <p>
            <span>Amertume : </span>
            {beer.amertume}
          </p>
          <p>
            <span>Couleur : </span>
            {beer.couleur}
          </p>
        </div>
      </div>
      <div className="background" />
    </Fragment>
  );
};
export default Beer;



// WEBPACK FOOTER //
// ./src/Components/Beer/Beer.js